import { useEffect, useState } from "react";
import axios from "axios";
import useChat from "../../hooks/useChat";
import { toast } from "react-toastify";
import websocketClient from "../../utils/websocketClient";

const SharePost = ({ postId, postLink, onClose,isTrue }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLIENT_URL =process.env.REACT_APP_CLIENT_BASE_URL

  const WS_URL = process.env.REACT_APP_WS_BASE_URL;

  const token = localStorage.getItem("access_token");

  const [connectedUsers, setConnectedUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [copied,setCopied]=useState(false)
  //  console.log("The connected users are:",connectedUsers)
  // console.log("the posti is:",postId)
  // console.log("the post link is:",postLink)
  const { sendMessage } = useChat();
  const baseUrl = CLIENT_URL;
  // const fullPostUrl = `${baseUrl}/post/${postId}?type=${postLink}`;
   const fullPostUrl = isTrue ? `${baseUrl}${postLink}` : `${baseUrl}/post/${postId}?type=${postLink}`;
 useEffect(() => {
  if (!copied) return; // only run when copied is true

  const timer = setTimeout(() => {
    setCopied(false);
  }, 1000);

  // Clean up the timer if component unmounts or copied changes
  return () => clearTimeout(timer);
}, [copied]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/user/chat/connected-users-list/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      })
      .then((res) => setConnectedUsers(res.data || []))
      .catch((err) => console.error("Failed to fetch users", err))
      .finally(() => setLoading(false));
  }, [BASE_URL, token]);

  const toggleSelectUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleSend = () => {
    if (selectedUsers.length === 0) return;

    selectedUsers.forEach((userId) => {
      const socketName = `chat-${userId}`;
      const url = `${WS_URL}/ws/chat/${userId}/`;

      websocketClient.connect(socketName, url, token);
      websocketClient.subscribe(socketName, (data) => {
        console.log(`[${socketName}] Message received:`, data);
      });

      websocketClient.send(socketName, {
        message: `Check this post: ${fullPostUrl}`,
      });
    });

    toast.success("Post shared successfully!");
    onClose();
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(fullPostUrl);
      setCopied(true)
    
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };

  return (
    
    
 <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div 
    className="bg-white rounded-2xl w-full max-w-md shadow-xl"
    onClick={(e) => e.stopPropagation()}
  >
    {/* Modal Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Share Post</h2>
          <p className="text-sm text-gray-500 mt-0.5">Share with your connections</p>
        </div>
      </div>
    </div>

    {/* Modal Content */}
    <div className="p-6">
      {loading ? (
        <div className="flex flex-col items-center justify-center py-8">
          <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin mb-3"></div>
          <p className="text-sm text-gray-500">Loading connections...</p>
        </div>
      ) : (
        <div className="max-h-64 overflow-y-auto pr-2">
          {connectedUsers && connectedUsers.map((user) =>{
             const userId = user?.user_profile?.id;

  if (!userId) return null;
           return   (
            <div 
              key={user?.user_profile?.id} 
              className={`flex items-center p-3 rounded-xl cursor-pointer transition-all duration-200 mb-2 ${
                selectedUsers?.includes(user.user_profile.id)
                  ? "bg-[#e8f0f7] border border-[#0f6abf]/20"
                  : "hover:bg-gray-50"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                toggleSelectUser(user.user_profile.id);
              }}
            >
              <div className="relative flex-shrink-0">
                <img
                  src={user?.user_profile?.profile_picture || "/default-avatar.png"}
                  alt={user.username}
                  className="w-12 h-12 rounded-lg object-cover border-2 border-white shadow-sm"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
              <div className="flex-1 ml-3 min-w-0">
                <span className="block text-sm font-medium text-gray-900 truncate">
                  {user?.user_profile.name || user.username}
                </span>
                <span className="text-xs text-gray-500">Online</span>
              </div>
              <div 
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                  selectedUsers.includes(user.user_profile.id)
                    ? "border-[#0f6abf] bg-[#0f6abf]"
                    : "border-gray-300"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSelectUser(user.user_profile.id);
                }}
              >
                {selectedUsers.includes(user.user_profile.id) && (
                  <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </div>
          )
          })}
        </div>
      )}
    </div>

    {/* Selected Count */}
    {!loading && selectedUsers.length > 0 && (
      <div className="px-6 pb-3">
        <div className="text-sm text-gray-600">
          {selectedUsers.length} connection{selectedUsers.length !== 1 ? 's' : ''} selected
        </div>
      </div>
    )}

    {/* Modal Footer */}
    <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
      <div className="flex items-center justify-end gap-3">
        <button 
          onClick={onClose} 
          className="px-4 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
        >
          Cancel
        </button>
        
        <button 
          onClick={handleCopyLink} 
          className="px-4 py-2.5 bg-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-300 transition-colors flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          {copied ? 'Copied' : 'Copy Link'}
        </button>
        
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleSend();
          }}
          disabled={selectedUsers?.length === 0}
          className={`px-4 py-2.5 font-medium rounded-xl transition-colors flex items-center gap-2 ${
            selectedUsers?.length === 0 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-[#0f6abf] text-white hover:bg-[#0a5ca8]'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          Send
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default SharePost;
